import { create } from 'zustand'
import { userSettingsRepository } from '@/shared/repositories/settings/userSettingsRepository'
import { DEFAULT_VIDAAS_AUTH_PREFERENCE, DEFAULT_VIDAAS_SESSION_MODE, type VidaasAuthPreference, type VidaasSessionMode } from '@/shared/lib/digitalSignaturePrefs'

type Preferences = { vidaasAuthPreference: VidaasAuthPreference; vidaasSessionMode: VidaasSessionMode }
const initial = () => ({
  ownerUserId: null as string | null,
  preferences: { vidaasAuthPreference: DEFAULT_VIDAAS_AUTH_PREFERENCE, vidaasSessionMode: DEFAULT_VIDAAS_SESSION_MODE } as Preferences,
  loaded: false, loading: false, saving: false,
})
interface State extends ReturnType<typeof initial> {
  load: (userId: string) => Promise<void>
  saveMode: (userId: string, mode: VidaasSessionMode) => Promise<void>
  reset: () => void
}
let epoch = 0
let active: { userId: string; promise: Promise<void> } | null = null

/** Preferências de apresentação do fluxo; não contém certificados, tokens nem sessão criptográfica. */
export const useDigitalSignaturePrefsStore = create<State>((set, get) => ({
  ...initial(),
  load: async (userId) => {
    if (active?.userId === userId) return active.promise
    if (get().ownerUserId !== userId) {
      epoch += 1
      set({ ...initial(), ownerUserId: userId })
    }
    const ticket = epoch
    set({ loading: true })
    const promise = userSettingsRepository.getDigitalSignaturePreferences(userId)
      .then((preferences) => {
        if (ticket === epoch) set({ preferences, loaded: true, loading: false })
      })
      .catch((error: unknown) => {
        if (ticket === epoch) set({ loading: false })
        throw error
      })
      .finally(() => { if (active?.promise === promise) active = null })
    active = { userId, promise }
    return promise
  },
  saveMode: async (userId, mode) => {
    if (get().ownerUserId !== userId || !get().loaded) await get().load(userId)
    if (get().ownerUserId !== userId) throw new Error('Sessão alterada. Tente novamente.')
    const ticket = epoch
    set({ saving: true })
    try {
      await userSettingsRepository.updateDigitalSignaturePreferences({ vidaasSessionMode: mode }, userId)
      if (ticket === epoch) set((state) => ({ preferences: { ...state.preferences, vidaasSessionMode: mode } }))
    } finally {
      if (ticket === epoch) set({ saving: false })
    }
  },
  reset: () => { epoch += 1; active = null; set(initial()) },
}))
